import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.authenticated()) {
    if (isTokenExpired()) {
      authService.logout();
      router.navigate(['/login']);
      return false;
    }
    
    if ((state.url.match('/companies') 
        || state.url.startsWith('/companies/page') 
        || state.url.startsWith('/companies/edit')
        || state.url.match('/companies/create')
        ) && !authService.isSuperAdmin()) {
      router.navigate(['/forbidden']);
      return false;
    }

    if ((state.url.match('/users') 
      || state.url.startsWith('/users/page') 
      || state.url.startsWith('/users/edit')
      || state.url.match('/users/create')

      ) && !(authService.isAdmin() || authService.isSuperAdmin()) ) {
      router.navigate(['/forbidden']);
      return false;
    }

    if ((  state.url.match('/adminCompany')
        || state.url.match('/positions')
        || state.url.startsWith('/positions/edit')
        || state.url.match('/positions/create')
        || state.url.match('/areas')
        || state.url.startsWith('/areas/edit')
        || state.url.match('/areas/create')
        || state.url.match('/divisions')
        || state.url.startsWith('/divisions/edit')
        || state.url.match('/divisions/create')
        || state.url.match('/benefitsGroup')
        || state.url.startsWith('/benefitsGroup/edit')
        || state.url.match('/benefitsGroup/create')
        || state.url.match('/signatures')
        || state.url.startsWith('/signatures/edit')
        || state.url.match('/signatures/create')
        || state.url.match('/holidays')
        || state.url.startsWith('/holidays/edit')
        || state.url.match('/holidays/create')
        || state.url.match('/benefitsCatalog')
        || state.url.startsWith('/benefitsCatalog/edit')
        || state.url.match('/benefitsCatalog/create')

        || state.url.match('/costsPerEmployeesCatalog')
        || state.url.startsWith('/costsPerEmployeesCatalog/edit')
        || state.url.match('/costsPerEmployeesCatalog/create')

        || state.url.match('/costsPerEmployeeGroup')
        || state.url.startsWith('/costsPerEmployeeGroup/edit')
        || state.url.match('/costsPerEmployeeGroup/create')

        || state.url.match('/withholdingsCatalog')
        || state.url.startsWith('/withholdingsCatalog/edit')
        || state.url.match('/withholdingsCatalog/create')

        || state.url.match('/withholdingsGroup')
        || state.url.startsWith('/withholdingsGroup/edit')
        || state.url.match('/withholdingsGroup/create')

        || state.url.match('/formulaGroup')
        || state.url.startsWith('/formulaGroup/edit')
        || state.url.match('/formulaGroup/create')

        || state.url.match('/variablesCatalog')
        || state.url.startsWith('/variablesCatalog/edit')
        || state.url.match('/variablesCatalog/create')

        || state.url.match('/objectsCatalog')
        || state.url.startsWith('/objectsCatalog/edit')
        || state.url.match('/objectsCatalog/create')

        ) && !authService.isAdmin()) {
      router.navigate(['/forbidden']);
      return false;
    }

    if ((state.url.match('/offers') 
        || state.url.startsWith('/offers/edit')
        || state.url.match('/offers/create')
        || state.url.match('/employee/upload')
        || state.url.match('/employee')
        || state.url.match('/budgetCalculation')
        || state.url.match('/formulaEvaluator')
        ) && !(authService.isRol('ROL_USER') || authService.isAdmin()) ) {
      router.navigate(['/forbidden']);
      return false;
    }

    if ((state.url.match('/requestedSignatures') 
        || state.url.startsWith('/requestedSignatures/review') 
        )  && !authService.isRol('ROL_AUT')) {
      router.navigate(['/forbidden']);
      return false;
    }

    return true;
  }
  router.navigate(['/login']);
  return false;
};

const isTokenExpired = () => {
  const authService = inject(AuthService);
  const token = authService.token;
  const payload = authService.getPayload(token);
  const exp = payload!.exp? payload!.exp : 0;
  const now = new Date().getTime() / 1000;
  return (now > exp) ? true : false;
}
